import { DataSource, HorizontalSpacer, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCopyOrderPrompt extends Layout {
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    labelWhichCompany: Label;
    panel1: Panel;
    sourceCopyControlLookup: DataSource;
    textboxCompanyId: Textbox;
}
